const CREATE_GROUP = "/group/create-group";

const UPDATE_GROUP = "/group/update-group";

const GET_GROUP_DETAILS = "/group/get-group-details";

const ADD_GROUP_MEMBER = "/group/add-group-member";

const GET_SINGLE_USER_GROUPS = "/group/get-single-user-groups";

const GET_SINGLE_GROUP_MEMBERS = "/group/get-single-group-members";

const DELETE_SINGLE_GROUP = "/group/delete-single-group";

const REMOVE_MEMBER_FROM_GROUP = "/group/remove-member-from-group";

export {
  CREATE_GROUP,
  GET_SINGLE_USER_GROUPS,
  UPDATE_GROUP,
  GET_GROUP_DETAILS,
  GET_SINGLE_GROUP_MEMBERS,
  ADD_GROUP_MEMBER,
  DELETE_SINGLE_GROUP,
  REMOVE_MEMBER_FROM_GROUP,
};
